module.exports = __webpack_public_path__ + "img/background.32b082e4.webp";